import { PeriodSelector as PeriodSelectorComponent } from './PeriodSelector.component';
import { connector } from './PeriodSelector.connector';

export const PeriodSelector = connector(PeriodSelectorComponent);
